// extracted by mini-css-extract-plugin
export default {"wrap":"OrderListRow_wrap__bdyHw","imgWrap":"OrderListRow_imgWrap__RZppr","border":"OrderListRow_border__Ztgi0","trackButton":"OrderListRow_trackButton__sYtEf"};